module.exports = __webpack_public_path__ + "img/info-system.a0c93575.svg";